import React from 'react';
import { Hero } from '../components/Hero';
import { SolutionSection } from '../components/SolutionSection';
import { ProductContents } from '../components/ProductContents';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  return <div className="min-h-screen bg-navy-900 font-sans selection:bg-gold-500/30" data-id="element-302">
      <Hero data-id="element-303" />
      <SolutionSection data-id="element-304" />
      <ProductContents data-id="element-305" />
      <BonusSection data-id="element-306" />
      <PricingSection data-id="element-307" />
      <TestimonialsSection data-id="element-308" />
      <FinalCTA data-id="element-309" />
      <SocialProofPopup data-id="element-310" />
    </div>;
}